import React, { useState, useEffect } from 'react';
import { useParams, Link } from 'react-router-dom';
// ✅✅✅ اصلاح: ایمپورت axiosInstance به جای axios و getAuthHeaders
import axiosInstance from '../../modules/api';
import { FaArrowLeft, FaBook, FaVideo, FaCheckCircle, FaLock, FaFileAlt, FaPencilAlt, FaSpinner } from 'react-icons/fa';
import StudentHeader from '../../components/layout/StudentHeader';
import '../../assets/styles/global.css';

const LessonListPage = () => {
    const { courseId } = useParams(); 
    
    const [lessons, setLessons] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [courseTitle, setCourseTitle] = useState(`دروس دوره`);

    const fetchLessons = async () => {
        setLoading(true);
        setError(null);
        try {
            if (!courseId) {
                setError("شناسه دوره یافت نشد.");
                setLoading(false);
                return;
            }
            
            // ✅✅✅ اصلاح: استفاده از axiosInstance که توکن را خودکار مدیریت می‌کند
            const courseInfoRes = await axiosInstance.get(`/core/student/courses/${courseId}/`);
            setCourseTitle(courseInfoRes.data.title || `دروس دوره ${courseId}`);

            // ✅✅✅ اصلاح: استفاده از axiosInstance
            const lessonsRes = await axiosInstance.get(
                `/core/student/courses/${courseId}/lessons/`
            );
            
            setLessons(lessonsRes.data); 
            
        } catch (err) {
            console.error("خطا در دریافت دروس:", err);
            // اگر خطای 401 رخ دهد، axiosInstance باید به صفحه لاگین هدایت کند
            // خطاهای دیگر (مثل 404) در اینجا نمایش داده می‌شوند
            setError(err.response?.data?.detail || "خطا در بارگذاری دروس از سرور.");
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchLessons();
    }, [courseId]); 

    // ... (بقیه فایل LessonListPage.js بدون تغییر باقی می‌ماند) ...

    const getIcon = (type) => {
        switch (type) {
            case 'Video': return <FaVideo className="text-red-500" />;
            case 'Quiz': return <FaPencilAlt className="text-green-500" />;
            default: return <FaFileAlt className="text-blue-500" />;
        }
    };

    const renderLessonList = () => {
        if (loading) return <div className="text-center py-5"><FaSpinner className="spinner" /> در حال بارگذاری دروس...</div>;
        if (error) return <div className="alert alert-danger">{error}</div>;
        if (lessons.length === 0) return <p className="text-center py-5">هیچ درسی برای این دوره پیدا نشد.</p>;

        return (
            <div className="lessons-grid">
                {lessons.map(lesson => {
                    const totalBlocks = lesson.total_blocks_count || 0;
                    const completedBlocks = lesson.completed_blocks_count || 0;
                    const isCompleted = totalBlocks > 0 && completedBlocks === totalBlocks;
                    const completionPercent = totalBlocks > 0 ? Math.round((completedBlocks / totalBlocks) * 100) : 0;
                    const isLocked = false; // منطق قفل بودن فعلا غیرفعال است

                    return (
                        <Link 
                            key={lesson.id} 
                            to={`/student/content/${lesson.id}`} 
                            className={`lesson-card-link ${isLocked ? 'locked' : ''}`}
                            onClick={(e) => { if (isLocked) e.preventDefault(); }}
                        >
                            <div className="lesson-card-info">
                                {isCompleted ? (
                                    <FaCheckCircle className="text-green-500 text-2xl" />
                                ) : isLocked ? (
                                    <FaLock className="text-red-500 text-lg" />
                                ) : (
                                    getIcon(lesson.content_blocks && lesson.content_blocks.length > 0 ? lesson.content_blocks[0].content_type : 'Text')
                                )}
                                
                                <span className={`font-medium ${isLocked ? 'text-gray-500' : 'text-gray-800'}`}>
                                    درس {lesson.order}: {lesson.title}
                                </span>
                            </div>
                            
                            <div className="text-right">
                                <div className="w-full bg-gray-200 rounded-full h-2">
                                    <div 
                                        className="bg-indigo-500 h-2 rounded-full" 
                                        style={{ width: `${completionPercent}%` }}
                                    ></div>
                                </div>
                                <span className={`text-xs mt-1 block ${isLocked ? 'text-red-500' : 'text-indigo-500'}`}>
                                    {isLocked ? 'قفل است' : `${completionPercent}% تکمیل`}
                                </span>
                            </div>
                        </Link>
                    );
                })}
            </div>
        );
    };

    return ( 
        <div className="app-layout-student">
            <StudentHeader />
            <div className="page-content">
                <Link to="/student/dashboard" className="button button-secondary mb-6 inline-flex items-center"><FaArrowLeft className="ml-2" /> بازگشت به داشبورد</Link>
                
                <div className="bg-white p-6 rounded-xl shadow-xl border-t-4 border-indigo-500">
                    <h1 className="text-2xl font-extrabold text-gray-900 mb-4 flex items-center">
                        <FaBook className="ml-3 text-indigo-600" /> {courseTitle}
                    </h1>
                    <p className="text-gray-600 mb-6 border-b pb-4">محتوای درسی و تمرینات تعاملی مربوط به واحدهای آموزشی شما.</p>
                    
                    {renderLessonList()}
                </div>
            </div>
        </div>
    );
};

export default LessonListPage;  